import ACTIONS from "../actions/actionTypes"

export const canProceedFromUI = (state = null, action) => {
  if (action.type === ACTIONS.IF_CAN_PROCEED) {
    return action.canProceed
  }
  return state
}
